export const getRestaurantFromList = (restaurantList, restaurantName) => {
  const filtered = restaurantList.filter(item => {
    return item.node.name === restaurantName
  })
  const restaurant = filtered && filtered[0] && filtered[0].node
  return restaurant
}

export const getPhotoCourtesy = (source) => `${source}`